const DECISION = {
	AP: 4,
	AE: 5,
} as const;

export default DECISION;
